export const spacerUrl =
    "data:image/webp;base64,UklGRkAAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAIAAAAAAFZQOCAYAAAAMAEAnQEqAQABAAJAOCWkAANwAP77nMAA";

const cache: {
    width: number;
    height: number;
    url: string;
}[] = [];

export function createBlank(width: number, height: number): string {
    let item = cache.find((x) => x.width == width && x.height == height);
    if (item == null) {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        item = {
            width,
            height,
            url: canvas.toDataURL("image/png"),
        };
        cache.push(item);
    }
    return item.url;
}
